import { Injectable, signal } from '@angular/core'

@Injectable({
	providedIn: 'root',
})
export class RecaptchaState {
	readonly token = signal<string | null>(null)
}
